<template>
    <portal to="body-content">
        <div class="modal fade join-the-club-modal" id="joinTheClubModal" tabindex="-1" aria-labelledby="joinTheClubLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="joinTheClubLabel">Join the Club</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <svg class="close-2"><use xlink:href="#close-2"></use></svg>
                        </button>
                    </div>
                    <div class="modal-body">

                        <form @submit.prevent="submit">

                            <!-- Column Container -->
                            <div class="col-sm-12 col-md-10 offset-md-1 mt-1 mb-3">
                                <div class="input-group">
                                    <input type="text"
                                           id="invite_code"
                                           name="invite_code"
                                           v-model="form.invite_code"
                                           placeholder="Enter Invite Code"
                                           aria-label="Recipient's username"
                                           aria-describedby="button-invite-code"
                                           class="form-control">

                                    <div class="input-group-append">
                                        <button  id="button-invite-code"
                                                 type="submit"
                                                 class="btn btn-outline-secondary"
                                                aria-label="Invite Code Button">
                                            Let's Go
                                            <svg class="arrow-right-2"><use xlink:href="#arrow-right-2"></use></svg>
                                        </button>
                                    </div>

                                </div>
                                <div class="error-message" v-if="form.errors.invite_code" v-text="form.errors.invite_code"></div>
                            </div>


                            <p class="alternative-text">No invite code? No problem. <br class="hide-md"><a href="/apply">Apply Here</a></p>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </portal>
</template>
<script>

import Form from '@/classes/Form'
import Helpers from '@/mixins/Helpers'

export default {

    mixins:[Helpers],

    data(){
        return {
            form: new Form({
                invite_code: '',
            })
        }
    },

    mounted() {
        this.$nextTick(() => {
            $('#joinTheClubModal').on('show.bs.modal', event => {
                event.preventDefault()
                this.checkCookies(event)
            });
        })
    },

    methods: {

        submit() {
            this.form.post(`/invite-code`)
                .then(response => {
                    this.redirectTo(`/apply?invite_code=${response.invite_code.value}`)
                })
        },

        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        },

        checkCookies() {
            if (document.cookie.indexOf('approveduser') > -1) {
                window.location.href = '/registration?u=' + this.getCookie("approveduser");
                return true;
            }

            if (document.cookie.indexOf('invite') > -1) {
                window.location.href = '/invite-registration/' + this.getCookie("invite");
                return true;
            }

            if (document.cookie.indexOf('share') > -1) {
                window.location.href = '/share-registration/' + this.getCookie("share");
                return true;
            }

            if (document.cookie.indexOf('regfunnel') > -1) {
                // The controller will redirect them to the join the club page if the reg funnel
                // is a direct registration funnel no_apply property
                window.location.href = '/registration';
                return true;
            }

            // if (document.cookie.indexOf('funnel') > -1) {
            //     window.location.href = '/apply';
            //     return true;
            // }

            return window.location.href = '/apply';
        }
    },

    computed:{
        isDisabled(){
            return this.form.invite_code == ''
        }
    }
}
</script>
